/** istanbul ignore file */
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import { PcvizTool } from '@mirage-projects/cw-models';

import { ActionToolbarString } from '../toolbar-configuration/action-toolbar.enum';
import { OptionToolbarData } from '../toolbar-configuration/option-toolbar';

export interface ToolChangeSelectionOptions {
    option: OptionToolbarData;
    maintainActiveTools?: boolean;
    emitSelectedOption?: boolean;
}

export type PcvizToolsMap = Map<ActionToolbarString, () => PcvizTool[]> | undefined;

@Injectable({ providedIn: 'root' })
export class ToolToolbarCommunicationService {
    selectedOption!: OptionToolbarData;

    private readonly selectOption$ = new Subject<ToolChangeSelectionOptions>();
    private readonly selectOptionObservable$ = this.selectOption$.asObservable();

    private readonly disablePcvizToolsByGroupSubject$ = new Subject<ActionToolbarString>();
    private readonly disablePcvizToolsByGroup$ = this.disablePcvizToolsByGroupSubject$.asObservable();

    changeSelection(option: ToolChangeSelectionOptions): void {
        this.selectOption$.next(option);
    }

    onChangeSelectOption(): Observable<ToolChangeSelectionOptions> {
        return this.selectOptionObservable$;
    }

    disablePcvizToolsByGroup(toolGroup: ActionToolbarString): void {
        this.disablePcvizToolsByGroupSubject$.next(toolGroup);
    }

    onDisablePcvizToolsByGroup(): Observable<ActionToolbarString> {
        return this.disablePcvizToolsByGroup$;
    }
}
